import { IParamsGetJobTitleLevelManagement } from "app/api/jobtitlelevel/model/job-title-level-management";

export const JobTitleLevelKeys = {
  allJobTitleLevels: ['JobTitleLevels'] as const,
  listJobTitleLevels: () => [...JobTitleLevelKeys.allJobTitleLevels, 'JobTitleLevels'] as const,
  listJobTitleLevel: (filters?: IParamsGetJobTitleLevelManagement) =>
    [...JobTitleLevelKeys.listJobTitleLevels(), { filters }] as const,
}
